(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/favorites/page.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/favorites/page.js');
"use strict";


const {
  useEffect,
  useContext,
  useMemo
} = React;
const {
  ReactIcon: Icon,
  ReactGrid: {
    GridCol,
    GridRow
  }
} = svs.ui;
const {
  getSortOptionById,
  ROUTES: {
    FAVORITES
  }
} = svs.eInstant.constants;
const {
  GameGrid
} = svs.eInstant.shared;
const Favorites = () => {
  var _getSortOptionById;
  const {
    InfoOverlay,
    Background,
    SortGames
  } = svs.eInstant.shared.components;
  const ScrollToTop = svs.eInstant.components.ScrollToTop;
  const {
    state: {
      gameUrl,
      categories = []
    }
  } = useContext(svs.eInstant.store.RouterContext);
  const favoriteCategory = categories.find(cat => cat === null || cat === void 0 ? void 0 : cat.favorites) || {
    games: []
  };
  const {
    update
  } = svs.eInstant.shared.hooks.useMetaTags({
    favoriteCategory
  });
  const [selected, setSelected] = svs.eInstant.shared.hooks.useLocalStorage(FAVORITES, 'tickets-einstant-sort-games', null, 60);
  const sortFn = (_getSortOptionById = getSortOptionById(selected)) === null || _getSortOptionById === void 0 ? void 0 : _getSortOptionById.sortFn;
  const sortedGames = useMemo(() => sortFn(favoriteCategory.games || []), [sortFn, favoriteCategory.games]);
  useEffect(() => {
    !gameUrl && update(FAVORITES);
  }, [favoriteCategory, gameUrl]);
  if (!sortedGames.length) {
    return React.createElement(Background, {
      classNames: "tickets-einstant-favorites-height"
    }, React.createElement("div", {
      className: "tickets-einstant-max-width w100"
    }, React.createElement("div", {
      className: "u-flex u-flex-column margin-top-3 margin-bottom-2 margin-h-1"
    }, React.createElement(GridRow, {
      className: "u-flex u-flex-column u-flex-align-items-center"
    }, React.createElement(GridCol, {
      xs: 12
    }, React.createElement("div", {
      className: "f-body u-flex u-flex-row u-flex-align-items-center"
    }, React.createElement(Icon, {
      color: "fc-fler-lotter-new-700 margin-right-half",
      icon: favoriteCategory.icon
    }), React.createElement("h1", {
      className: "h1 fc-fler-lotter-new-700 margin-0"
    }, favoriteCategory.title)))), React.createElement(GridRow, {
      className: "u-flex u-flex-column u-flex-align-items-center"
    }, React.createElement(GridCol, {
      xs: 12
    }, React.createElement("div", {
      className: "tickets-einstant-no-games u-flex u-flex-justify-content-center u-flex-align-items-center"
    }, React.createElement("div", null, React.createElement("h4", {
      className: "fc-fler-lotter-new-700 h4"
    }, "Du har inte lagt till n\xE5gra favoriter \xE4nnu."))))))));
  }
  return React.createElement(Background, {
    classNames: "tickets-einstant-favorites-height"
  }, React.createElement(ScrollToTop, null), React.createElement(InfoOverlay, {
    onCloseUrl: "".concat(svs.core.data.baseUrl).concat(FAVORITES)
  }), React.createElement("div", {
    className: "tickets-einstant-max-width w100"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-v-2 margin-h-1"
  }, React.createElement(GridRow, {
    className: "u-flex u-flex-align-items-center",
    gutter: "0"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 10,
    md: 8,
    xs: 12
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-top-1"
  }, React.createElement("div", {
    className: "f-body u-flex u-flex-row u-flex-align-items-center margin-bottom-2"
  }, React.createElement(Icon, {
    color: "fc-fler-lotter-new-700 margin-right-half",
    icon: favoriteCategory.icon
  }), React.createElement("h1", {
    className: "h1 fc-fler-lotter-new-700 margin-0"
  }, favoriteCategory.title)))), React.createElement(GridCol, {
    am: 4,
    className: "tickets-einstant-margin-left-auto",
    lg: 2,
    md: 4,
    xs: 12
  }, React.createElement(SortGames, {
    selected: selected,
    setSelected: setSelected
  }))), React.createElement("div", {
    className: "margin-top-1-half"
  }, React.createElement(GameGrid, {
    games: sortedGames
  })))));
};
setGlobal('svs.eInstant.lobby.Favorites', Favorites);

 })(window);